<template>
  <div class="accountPage">
    <Notification />
  </div>
</template>

<script>

import Notification from '@/components/elements/Notification'

export default {
  name: 'AccountPage',
  components: {
    'Notification': Notification
  }
}

</script>



// WEBPACK FOOTER //
// src/components/pages/Account.vue